import { GridAlignment } from "@mui/x-data-grid-pro";

export type Column<T> = {
  headerName: string;
  align?: string;
  headerAlign?: GridAlignment;
  headerPadding?: string;
  width?: number | string;
  renderCell: (item: T) => React.ReactNode;
};

export const reorder = (list: any, startIndex: number, endIndex: number) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};
